import { api } from './api';
import { ApiResponse } from 'utils/types/api';

export interface ProjectStage {
  id: string;
  stageName: string;
  enabled: boolean;
  process_id: string;
}

export interface ProjectProcess {
  id: string;
  processName: string;
  enabled: boolean;
  projectStages: ProjectStage[];
  stagesOrdering: string[];
}

export const getProjectProcesses = async () => {
  const response = await api.get<ApiResponse<ProjectProcess[]>>(
    '/project/process/all'
  );
  return response.data;
};
